// One control for a limit value: "use the plan's value" or a specific value.
import { Group, NumberInput, SegmentedControl, Select, Text } from "@mantine/core";
import { formatLimit, type LimitSpec } from "../../lib/api";

export const INHERIT = undefined;

/** value === undefined means "not set here" (inherit). */
export function LimitInput({ spec, value, onChange, inheritLabel }: {
  spec: LimitSpec; value: unknown; onChange: (v: unknown) => void; inheritLabel?: string;
}) {
  const inherit = inheritLabel !== undefined;
  if (spec.kind === "bool") {
    const cur = value === undefined ? "inherit" : value ? "on" : "off";
    const data = [...(inherit ? [{ value: "inherit", label: inheritLabel! }] : []), { value: "on", label: "On" }, { value: "off", label: "Off" }];
    return (
      <SegmentedControl size="xs" value={inherit ? cur : cur === "inherit" ? "off" : cur} data={data}
        onChange={(v) => onChange(v === "inherit" ? INHERIT : v === "on")} aria-label={spec.label} />
    );
  }
  if (spec.kind === "choice") {
    const data = [...(inherit ? [{ value: "__inherit", label: inheritLabel! }] : []), ...spec.choices.map((c) => ({ value: c, label: c }))];
    return (
      <Select size="xs" w={160} data={data} value={value === undefined ? (inherit ? "__inherit" : null) : String(value)}
        onChange={(v) => onChange(v === "__inherit" || v === null ? INHERIT : v)} allowDeselect={false} aria-label={spec.label} />
    );
  }
  return (
    <Group gap={6} wrap="nowrap">
      <NumberInput size="xs" w={140} value={value === undefined ? "" : (value as number)} placeholder={inheritLabel}
        min={0} allowDecimal={spec.kind === "float"} thousandSeparator="," aria-label={spec.label}
        onChange={(v) => onChange(v === "" || v === undefined ? INHERIT : Number(v))} />
      {spec.unit && <Text size="xs" c="dimmed">{spec.unit}</Text>}
    </Group>
  );
}

export function planValueLabel(spec: LimitSpec, planValue: unknown) {
  return `Plan (${formatLimit(spec, planValue)})`;
}
